import {PrismaSelect as PalJSPrismaSelect} from "@paljs/plugins";

export default class PrismaSelect extends PalJSPrismaSelect {
    filterBy(modelName: string, selectObject: any) {
        const model = this.model(modelName);
        if (model && typeof selectObject === 'object') {
            let defaultFields = {};
            if (this.defaultFields && this.defaultFields[modelName]) {
                defaultFields = this.defaultFields[modelName] instanceof Function
                 ? this.defaultFields[modelName](selectObject)
                 : this.defaultFields[modelName];
            }
            const filteredObject = {
                ...selectObject,
                select: { ...defaultFields },
            };
            Object.keys(selectObject.select).forEach((key) => {
                const field = this.field(key, model);
                if (field) {
                    if (field.kind !== 'object') {
                        filteredObject.select[key] = true;
                    } else {
                        const subModelFilter = this.filterBy(
                            field.type,
                            selectObject.select[key],
                        );
                        if (Object.keys(subModelFilter.select).length > 0) {
                            filteredObject.select[key] = subModelFilter;
                        }
                    }
                }
            });
            return filteredObject;
        } else {
            return selectObject;
        }
    }
}
